import { render, staticRenderFns } from "./ed-class-schedule-header.component.vue?vue&type=template&id=6b784f5e&scoped=true&"
import script from "./ed-class-schedule-header.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-schedule-header.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-schedule-header.component.scss?vue&type=style&index=0&id=6b784f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b784f5e",
  null
  
)

export default component.exports